import React from 'react'
import { createPortal } from 'react-dom'
import { connect, ConnectedProps } from 'react-redux'

import { Toast } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/toast/Toast'
import { BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { ToastContent } from '@lyrahealth-inc/ui-core-crossplatform/src/ui-models/toast/Toast'

import { getToastContent } from '../../../data/lyraTherapy/clientSelectors'
import { RootState } from '../../../data/store'
import { clearToastContent } from '../../../lyraTherapy/data/ltToastAutoActions'
import { COMPACT_MESSENGER_Z_INDEX } from '../../../lyraTherapy/messages/constants'

type ToastContanerProps = ConnectedProps<typeof connector> & {
  hasBiggerMarginLeftValue?: boolean
}

const ToastContainer = ({ toast, clearToastContent, hasBiggerMarginLeftValue }: ToastContanerProps) => {
  if (!toast) {
    return null
  }
  const { text, id, toastType, duration, link, persistent } = toast
  if (!text || !id) {
    return null
  }
  return createPortal(
    <Toast
      key={id}
      text={text}
      toastType={toastType}
      id={id}
      textSize={BodyTextSize.SMALL}
      onAnimationEnd={() => clearToastContent(id)}
      delay={500}
      duration={duration}
      link={link}
      persistent={persistent}
      containerStyle={{
        zIndex: COMPACT_MESSENGER_Z_INDEX + 1,
        ...(hasBiggerMarginLeftValue ? { left: 120 } : {}),
      }}
    />,
    document.body,
  )
}

type StateProps = {
  toast: ToastContent | null
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    toast: getToastContent(state),
  }
}

const mapDispatchToProps = {
  clearToastContent,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(ToastContainer)
